// extracted by mini-css-extract-plugin
module.exports =  {"root":"sklI0leDNHYJ8N9EHFc9"};